import config from 'src/config'
import { load } from 'recaptcha-v3'

const getRecaptchaToken = async (action = 'submit') => {
  const recaptcha = await load(config.googleRecaptchaKey)
  const token = await recaptcha.execute(action)
  return token
}

export default getRecaptchaToken
